import axios from 'axios';
import {debug} from 'util';
var instance = axios.create ({
  headers: {
    'X-AUTH-TOKEN': window.localStorage.getItem ('ei_token'),
  },
});

console.log ('process data');

const apiBaseUrl = process.env.API_BASE_URL;

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function fetch (url, params = {}) {
  return new Promise ((resolve, reject) => {
    axios
      .get (apiBaseUrl + url, {
        params,
        headers: {
          'X-AUTH-TOKEN': window.localStorage.getItem ('ei_token'),
        },
      })
      .then (response => {
        standardProcessResponse (response, resolve, reject);
      })
      .catch (err => {
        console.error ('network error');
      });
  });
}
/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post (url, data) {
  var qs = require ('queryString');
  return new Promise ((resolve, reject) => {
    instance
      .post (apiBaseUrl + url, data)
      .then (response => {
        standardProcessResponse (response, resolve, reject);
      })
      .catch (err => {
        console.error ('network error');
      });
  });
}

export function postImg (url, data) {
  var config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  return new Promise ((resolve, reject) => {
    axios
      .post (apiBaseUrl + url, data, config)
      .then (response => {
        standardProcessResponse (response, resolve, reject);
      })
      .catch (err => {
        console.error ('network error');
      });
  });
}

function standardProcessResponse (response, resolve, reject) {
  var httpStatus = response.status.toString ();
  if (/2[\d]{2}/.test (httpStatus)) {
    // 200+
    if (response.data.Success === true) {
      resolve (response.data.Result);
    } else {
      // this.$message.error (response.data.Error.Message);
      reject (response.data);
    }
  } else if (/3[\d]{2}/.test (httpStatus)) {
    //
  } else if (/4[\d]{2}/.test (httpStatus)) {
  } else if (/5[\d]{2}/.test (httpStatus)) {
  }
}

export function postUrl (url, data = {}) {
  if (url.indexOf ('?' === -1)) {
    url += '?';
  }
  for (var index in data) {
    url += index + '=' + data[index] + '&';
  }
  // var qs = require("queryString");
  return new Promise ((resolve, reject) => {
    axios
      .post (apiBaseUrl + url)
      .then (response => {
        standardProcessResponse (response, resolve, reject);
      })
      .catch (err => {
        reject (err);
      });
  });
}
// export function post(config){
//  var qs = require("queryString");
//  var config={
//              url: "",
//              data:{},
//              headers: {"Content-Type": "multipart/form-data"},
//              requestHeader:{'Content-Type':'application/json'},
//              responseType: 'json'
//        }
//   return new Promise((resolve,reject) => {
//     axios.post(config)
//          .then(response => {
//            resolve(response.data);

//          },err => {
//            reject(err)
//          })
//   })
// }



// WEBPACK FOOTER //
// ./src/js/http.js